import { apiRoutes } from "../apiRoutes";
import axios from "../appAxios";

export const getFeed = async (queryParams) => {
  const qs = queryParams ? new URLSearchParams(queryParams).toString() : "";
  const response = await axios.get(`${apiRoutes.GET_FEED}?${qs}`);
  return response.data;
};

export const getFeedShopRecommendations = async (excludeIds = []) => {
  const query = excludeIds.length
    ? `?${new URLSearchParams({ excludeIds: excludeIds.join(",") }).toString()}`
    : "";
  const response = await axios.get(
    `${apiRoutes.GET_FEED_SHOP_RECOMMENDATIONS}${query}`,
  );
  return response.data;
};

export const getFeedPeopleRecommendations = async (excludeIds = []) => {
  const query = excludeIds.length
    ? `?${new URLSearchParams({ excludeIds: excludeIds.join(",") }).toString()}`
    : "";
  const response = await axios.get(
    `${apiRoutes.GET_FEED_PEOPLE_RECOMMENDATIONS}${query}`,
  );
  return response.data;
};

export const getFeedConfig = async () => {
  const response = await axios.get(apiRoutes.GET_FEED_CONFIG);
  return response.data;
};

export const getReviewFeed = async (queryParams) => {
  const qs = queryParams ? new URLSearchParams(queryParams).toString() : "";
  const response = await axios.get(`${apiRoutes.GET_FEED_REVIEWS}?${qs}`);
  return response.data;
};
